@if (context) {
  <div class="calendar-area">
    <appointment-calendar [context]="context" (selectTimeRange)="onSelectedDateTimeRangeChanged($event)"></appointment-calendar>
  </div>
  @if (form) {
    <div class="form-area modern-form" [formGroup]="form">
      <div class="fieldset form-content">
        <div class="field">
          <label class="required">Resources</label>
          <div class="value">
            @if (context.source === Source.Web) {
              <appointment-resource-picker [fetch]="PickerFetch.Manual" [multiple]="false" [data]="context.resources" formControlName="resource"></appointment-resource-picker>
            } @else {
              <contractor-allocation-employee-picker [fetch]="PickerFetch.Manual" [multiple]="false" [unassigned]="true" [parentId]="$safeNavigationMigration(context.contractor?._id)" [request]="context.resourceRequest" formControlName="contractorResource" [closeOnSelect]="true"> </contractor-allocation-employee-picker>
            }
          </div>
        </div>
        @if (isOpportunityEntity) {
          <div class="field">
            <label>Name</label>
            <div class="value">
              <input type="text" formControlName="name" placeholder="<Name>" />
            </div>
          </div>
        }
        <div class="field">
          <label>Start Date</label>
          <div class="value">
            <luxon-calendar [formControl]="dateControl" dateFormat="DD - dd/MM/yyyy" [zone]="context.timezone" appendTo="body"></luxon-calendar>
          </div>
        </div>
        <div class="info-group">
          <div class="field">
            <label>Start</label>
            <div class="value">
              <luxon-calendar formControlName="startDate" [timeOnly]="true" [zone]="context.timezone" [showZone]="false" appendTo="body"></luxon-calendar>
            </div>
          </div>
          <div class="field">
            <label>Finish</label>
            <div class="value">
              <luxon-calendar formControlName="endDate" [timeOnly]="true" [zone]="context.timezone" [showZone]="false" #endDate appendTo="body"></luxon-calendar>
            </div>
          </div>
        </div>
        @if (!isEdit) {
          <div class="field">
            <label>Additional Days</label>
            <div class="value">
              <input type="text" onlyNumbers formControlName="additionalDays" placeholder="<Set Additional Days>">
            </div>
          </div>
        }
        <div class="field">
          <label>Booking Status</label>
          <div class="value">
            <ng-select [items]="bookingStatusItems" formControlName="bookingStatus" [clearable]="false" placeholder="<Set Booking Status>"></ng-select>
          </div>
        </div>
        @if (isOpportunityEntity) {
          <div class="field">
            <label>Type</label>
            <div class="value">
              <ng-select [items]="typeOptions" placeholder="<Type>" formControlName="type">
              </ng-select>
            </div>
          </div>
        }
        <div class="field">
          <label>Note</label>
          <div class="value">
            <textarea formControlName="note" placeholder="<Optional Note>" cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" rows="1"></textarea>
          </div>
        </div>
        @if (isEdit && isOpportunityEntity) {
          <div class="field">
            <label>Status</label>
            <div class="value">
              <ng-select [items]="statusOptions" placeholder="<Status>" formControlName="status">
              </ng-select>
            </div>
          </div>
        }
        <div class="actions">
          <button class="btn btn-cancel" type="button" (click)="onClose()">Cancel</button>
          @if (canSave) {
            <button class="btn btn-primary" [disabled]="$safeNavigationMigration(form?.invalid)" type="button" (click)="onSave()">
              Save
            </button>
          }
        </div>
      </div>
    </div>
  }
}